export default {"src":"/_next/static/media/blackCap.a14f7210.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};